import React from "react";

import { makeStyles } from "tss-react/mui";

import Toolbar from "@mui/material/Toolbar";

const useStyles = makeStyles()((theme) => ({
  PanelTitle: {
    color: "#ed6c02",
    paddingLeft: "8px !important",
    paddingRight: "8px !important",
  },
}));

const SmallToolbar = ({ children, className, ...props }) => {
  const { classes } = useStyles();

  return (
    <Toolbar variant="dense" className={`${classes.PanelTitle}${!!className ? " " + className : ""}`} {...props}>
      {children}
    </Toolbar>
  );
};

export default SmallToolbar;
